import { createSlice } from '@reduxjs/toolkit';
import publicIp from 'react-public-ip';

function getDeviceType() {
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobile =
    /mobile|iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(
      userAgent,
    );

  return isMobile ? 'mobile' : 'desktop';
}

const LANGUAGES = ['en', 'ru', 'es', 'pt', 'fa', 'hi', 'ar'];
const defaultLanguage = { code: 'en', name: 'English', id: 1 };

const getLanguage = () => {
  const language = `${window?.localStorage?.getItem('broker-language')}`;

  if (language === 'null') {
    localStorage.setItem('broker-language', JSON.stringify(defaultLanguage));
    return defaultLanguage;
  }

  const parsedLanguage = JSON.parse(language);

  if (LANGUAGES.includes(parsedLanguage?.code)) return parsedLanguage;

  return defaultLanguage;
};

const initialState = {
  userAgent: navigator.userAgent || '',
  ip: (await publicIp.v4()) || '0.0.0.0',
  deviceType: getDeviceType() || '',

  screenHeight: null,
  screenWidth: null,

  countries: [],

  languages: [
    { code: 'en', name: 'English', id: 1 },
    { code: 'ru', name: 'Русский', id: 2 },
    { code: 'es', name: 'Español', id: 3 },
    { code: 'pt', name: 'Português', id: 4 },
    { code: 'fa', name: 'فارسی', id: 5 },
    { code: 'hi', name: 'हिन्दी', id: 6 },
    { code: 'ar', name: 'العربية', id: 7 },
  ],
  language: getLanguage(),
  translation: null,

  displayLoader: false,
  displayModal: false,
  displayMenu: false,
  displayProfile: false,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setScreenHeight: (state, action) => {
      state.screenHeight = action.payload;
    },
    setScreenWidth: (state, action) => {
      state.screenWidth = action.payload;
    },

    setCountries: (state, action) => {
      state.countries = action.payload;
    },

    setLanguages: (state, action) => {
      state.languages = action.payload;
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
    setTranslation: (state, action) => {
      state.translation = action.payload;
    },

    setDisplayLoader: (state, action) => {
      state.displayLoader = action.payload;
    },
    setDisplayModal: (state, action) => {
      state.displayModal = action.payload;
    },
    setDisplayMenu: (state, action) => {
      state.displayMenu = action.payload;
    },
    setDisplayProfile: (state, action) => {
      state.displayProfile = action.payload;
    },
  },
});

export const {
  setScreenHeight,
  setScreenWidth,

  setCountries,

  setLanguages,
  setLanguage,
  setTranslation,

  setDisplayLoader,
  setDisplayModal,
  setDisplayMenu,
  setDisplayProfile,
} = appSlice.actions;

export default appSlice.reducer;
